import { DatePipe } from "@angular/common";
import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
} from "@angular/core";
import { CellEditArgs, DataStateChangeEventArgs, GridComponent, parentsUntil, QueryCellInfoEventArgs, SelectionSettingsModel, TextWrapSettingsModel } from "@syncfusion/ej2-angular-grids";
import { ToastrService } from "ngx-toastr";
import { GlobalComponent } from "src/app/global/global.component";
import { GeneralService } from "src/app/service/general.service";
import { CSGVListBO, functionpermission, PurchaseVListBO, timesheetVError, TimesheetVListBO, transactionVListBO, UpdateClaimBO, VerificationBO } from "./verifications.model";
import { takeUntil } from "rxjs/operators";
import { Observable, Subject } from "rxjs";
import { VerificationsService } from "./verifications.service";
import { HttpErrorResponse } from "@angular/common/http";
import { TimesheetVerificationsService } from "./timesheet-verifications.service";
import { TransactionVerificationsService } from "./transaction-verifications.service";
import { PurchaseVerificationsService } from "./purchase-verifications.service";
import { IMyDpOptions } from "mydatepicker";
import { claiminput } from "../claims/claims.model";
import { DateService } from "src/app/date.service";
import { CombinedVerificationsService } from "./combined-verifications.service";

@Component({
    selector: "app-verifications",
    templateUrl: "./verifications.component.html",
    styleUrls: ["./verifications.component.scss"],
})
export class VerificationsComponent implements OnInit {
    public sendToBillinProgress: boolean = false;
    @Input() fromClaim: claiminput = new claiminput();
    @Output() outclaim = new EventEmitter<string>();
    public showTimesheetTab: boolean = false;
    public showTransactionTab: boolean = false;
    public showPurchaseTab: boolean = false;
    public showCSGTab: boolean = false;

    public onDestroy$: Subject<void> = new Subject<void>();
    verificationBO: VerificationBO = new VerificationBO();
    AllEmployeeList: any[] = [];
    AllClientList: any[] = [];
    activeTab: string = "TimesheetVerification";
    public initialPage: object;
    public formatOptions: object;
    public checkparams;
    TimesheetGridList = new TimesheetVListBO();
    @ViewChild("gridTimesheetV") public gridTimesheetV: GridComponent;
    timesheetVList: any[] = [];
    selectedtimesheets: any[] = [];
    public filterOptions: object;
    public selectionOptions: SelectionSettingsModel;
    documentType: string = "";
    TimesheetVerficationList: any[] = [];
    ErrorNotesTimesheetV: string;
    public GridTimesheetVList: Observable<DataStateChangeEventArgs>;
    selIndex: any[] = [];
    public wrapSettings: TextWrapSettingsModel;
    isEnabled: boolean = false;
    errorlist1: any[] = [];
    showerrorlist1: timesheetVError[] = [];
    showerrorlistfilter1: timesheetVError[] = [];
    fp: functionpermission = new functionpermission();
    result3: any = [];
    fromDate: any;
    toDate: any;

    selectedtransactions: any[] = [];
    TransactionGridList = new transactionVListBO();
    @ViewChild("gridTransactionV") public gridTransactionV: GridComponent;
    public GridTransactionVList: Observable<DataStateChangeEventArgs>;
    transactionVList: any[] = [];
    TransactionVerficationList: any[] = [];
    errorlist2: any[] = [];
    //showerrorlist2: timesheetVError[] = [];
    //showerrorlistfilter2: timesheetVError[] = [];

    selectedpurchases: any[] = [];
    errorlist3: any[] = [];
    PurchaseGridList = new PurchaseVListBO();
    @ViewChild("gridPurchaseV") public gridPurchaseV: GridComponent;
    public GridPurchaseVList: Observable<DataStateChangeEventArgs>;
    purchaseVList: any[] = [];
    PurchaseVerficationList: any[] = [];

    selectedcsgs: any[] = [];
    errorlist4: any[] = [];
    CSGGridList = new CSGVListBO();
    @ViewChild("gridCSGV") public gridCSGV: GridComponent;
    public GridCSGVList: Observable<DataStateChangeEventArgs>;
    csgVList: any[] = [];
    CSGVerficationList: any[] = [];
    validationStatusList = [{ Key: "Ready", Value: "Ready"}, {Key: "Validate", Value: "Validate"}]
    BillTypeList = [{ Key: "CSG", Value: "CSG"}, {Key: "CFSS", Value: "CFSS"}]
    public myDatePickerOptions: IMyDpOptions = {
        dateFormat: "mm/dd/yyyy",
        disableSince: {
            year: new Date().getFullYear(),
            month: new Date().getMonth() + 1,
            day: new Date().getDate() + 1,
        },
        showClearDateBtn: true,
        editableDateField: true,
    };
    private DecimalColumns: string[] = ["PAYRATE", "TOTALHOURS", "OVERTIMEHOURS", "TOTALAMOUNT", "EXCEEDAMOUNT", "HOURS", "RATE"];
    ApproveFilter:any="All";
    constructor(
        public verificationsService: VerificationsService,
        public toasterService: ToastrService,
        public global: GlobalComponent,
        public generalservice: GeneralService,
        private changeDetector: ChangeDetectorRef,
        public datePipe: DatePipe,
        public timesheetVListService: TimesheetVerificationsService,
        public transactionVListService: TransactionVerificationsService,
        public purchaseVListService: PurchaseVerificationsService,
        public dateservice: DateService,
        public combinedVerificationService: CombinedVerificationsService
    ) {
        this.GridTimesheetVList = this.timesheetVListService;
        this.GridTransactionVList = this.transactionVListService;
        this.GridPurchaseVList = this.purchaseVListService;
        this.GridCSGVList = this.combinedVerificationService;
    }

    ngOnInit(): void {
        this.formatOptions = { type: "date", format: "MM/dd/yyyy" };
        this.initialPage = { pageSizes: ["10", "20", "50", "100", "250"], pageSize: 250 };
        this.filterOptions = { type: "Menu" };
        this.selectionOptions = { checkboxOnly: true };
        this.wrapSettings = { wrapMode: "Content" };

        if (this.fromClaim.from == "Claim") {
            let start = new Date(this.fromClaim.start);
            this.fromDate = start.getMonth() + 1 + "/" + start.getDate() + "/" + start.getFullYear();
            let end = new Date(this.fromClaim.end);
            this.toDate = end.getMonth() + 1 + "/" + end.getDate() + "/" + end.getFullYear();
            this.TimesheetGridList.ids = this.fromClaim.ids;
            if (this.fromClaim.claimType == 'Timesheet') {
                this.showTimesheetTab = true;
                this.showPurchaseTab = this.showTransactionTab = this.showCSGTab = false;
                this.activeTab = "TimesheetVerification";
                this.getTimesheetVList();
            }
            if (this.fromClaim.claimType == 'Transaction') {
                this.showTransactionTab = true;
                this.showPurchaseTab = this.showTimesheetTab = this.showCSGTab = false;
                this.activeTab = "TransactionVerification";
                this.getTransactionVList();
            }
            if (this.fromClaim.claimType == 'PurchaseRequest') {
                this.showPurchaseTab = true;
                this.showTransactionTab = this.showTimesheetTab = this.showCSGTab = false;
                this.activeTab = "PurchseVerification";
                this.getPurchaseVList();
            }
            if (this.fromClaim.claimType == 'CSG') {
                this.showCSGTab = true;
                this.showTransactionTab = this.showTimesheetTab = this.showPurchaseTab = false;
                this.activeTab = "CSGVerification";
                this.getCSGVList();
            }
        } else {
            this.showTimesheetTab = this.showTransactionTab = this.showPurchaseTab = this.showCSGTab = true;
            this.fromDate = this.toDate = new Date().getMonth() + 1 + "/" + new Date().getDate() + "/" + new Date().getFullYear();
            this.getTimesheetVList();
        }

        this.checkparams = { checked: false };

        this.getClientDropDown();
        this.getEmployeesDropdown();
        this.getpermission();
    }

    DateFormat(event, type, name) {
        if (type == "inputchanged") {
            if (name == "FromDate") {
                let val = this.dateservice.inputFeildchangeReturnall(event);
                if (val != undefined) {
                    let datevalue = this.dateservice.inputFeildchangeReturnall(event);
                    this.fromDate = datevalue;
                }
            }
            if (name == "ToDate") {
                let val = this.dateservice.inputFeildchangeReturnall(event);
                if (val != undefined) {
                    let datevalue = this.dateservice.inputFeildchangeReturnall(event);
                    this.toDate = datevalue;
                }
            }
        }
        if (type == "datechanged") {
            if (name == "FromDate") {
                let val = this.dateservice.Datechange(event);
                if (val != undefined) {
                    let datevalue = this.dateservice.Datechange(event);
                    this.fromDate = datevalue;
                }
            }
        }
        if (name == "ToDate") {
            let val = this.dateservice.Datechange(event);
            if (val != undefined) {
                let datevalue = this.dateservice.Datechange(event);
                this.toDate = datevalue;
            }
        }
    }

    getActiveTab(TabChange) {
        this.activeTab = TabChange;
        if (this.activeTab == "TimesheetVerification") {
            this.selectedpurchases = this.selectedtransactions = this.selectedcsgs = [];
            this.TimesheetGridList.pageitem=this.gridTimesheetV.pagerModule.pagerObj.pageSize;
            this.getTimesheetVList();
        }
        if (this.activeTab == "TransactionVerification") {
            this.selectedtimesheets = this.selectedpurchases = this.selectedcsgs = [];
            this.TransactionGridList.pageitem = this.gridTransactionV.pagerModule.pagerObj.pageSize;
            this.getTransactionVList();
        }
        if (this.activeTab == "PurchseVerification") {
            this.selectedtimesheets = this.selectedtransactions = this.selectedcsgs = [];
            this.PurchaseGridList.pageitem = this.gridPurchaseV.pagerModule.pagerObj.pageSize;
            this.getPurchaseVList();
        }
        if (this.activeTab == "CSGVerification") {
            this.selectedtimesheets = this.selectedtransactions = this.selectedpurchases = [];
            this.CSGGridList.pageitem = this.gridCSGV.pagerModule.pagerObj.pageSize;
            this.verificationBO.billType="CSG";
            this.getCSGVList();
        }
    }

    getpermission() {
        if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId != null && this.global.globalAgencyId != undefined && this.global.globalAgencyId != '')) {
            let params = new URLSearchParams();
            params.append("pagecode", "verifications");
            params.append("roleId", this.global.roleId);
            params.append("agencyId", this.global.globalAgencyId)
            this.verificationsService.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
                if (data != null) {
                    this.fp = data;
                }
                else {
                    this.fp = new functionpermission();
                }
            }, (err: HttpErrorResponse) => {
                this.fp = new functionpermission();
            })
        }
    }

    //...................GetAllClientDropDown.............
    getClientDropDown() {
        this.verificationsService.GetAllClientDropDown()
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(
                (data: any) => {
                    this.AllClientList = data;
                },
                (err: any) => {
                    if (err) {
                        this.toasterService.error(err, "Error"), 8000;
                    }
                }
            );
    }

    //................GetAllEmployeesDropdown.............
    getEmployeesDropdown() {
        this.verificationsService.GetAllEmployeesDropdown()
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(
                (data: any) => {
                    this.AllEmployeeList = data;
                },
                (err: any) => {
                    if (err) {
                        this.toasterService.error(err, "Error"), 8000;
                    }
                }
            );
    }

    validatebutton(args: QueryCellInfoEventArgs) {
        if (args.column.field == "validate") {
            if (args.data["buttoncolor"] == "red") {
                args.cell.firstElementChild.firstElementChild.innerHTML = "Validate";
                args.cell.firstElementChild.firstElementChild.classList.add("btn_colorRed");
            }
            if (args.data["buttoncolor"] == "green") {
                args.cell.firstElementChild.firstElementChild.innerHTML = "Ready";
                args.cell.firstElementChild.firstElementChild.classList.add("btn_color");
            }
        }
    }

    public onActionComplete(G) {
        if (this.activeTab == "TimesheetVerification") {
            this.TimesheetGridList.currentpageno =
                this.gridTimesheetV.pagerModule.pagerObj.currentPage;
            this.TimesheetGridList.pageitem =
                this.gridTimesheetV.pagerModule.pagerObj.pageSize;
            if (G.name == "actionBegin" && G.requestType == "filterbeforeopen") {
                this.TimesheetGridList.type = G.columnType;
            }
        }
        if (this.activeTab == "TransactionVerification") {
            this.TransactionGridList.currentpageno =
                this.gridTransactionV.pagerModule.pagerObj.currentPage;
            this.TransactionGridList.pageitem =
                this.gridTransactionV.pagerModule.pagerObj.pageSize;
            if (G.name == "actionBegin" && G.requestType == "filterbeforeopen") {
                this.TransactionGridList.type = G.columnType;
            }
        }
        if (this.activeTab == "PurchseVerification") {
            this.PurchaseGridList.currentpageno =
                this.gridPurchaseV.pagerModule.pagerObj.currentPage;
            this.PurchaseGridList.pageitem =
                this.gridPurchaseV.pagerModule.pagerObj.pageSize;
            if (G.name == "actionBegin" && G.requestType == "filterbeforeopen") {
                this.PurchaseGridList.type = G.columnType;
            }
        }
        if (this.activeTab == "CSGVerification") {
            this.CSGGridList.currentpageno =
                this.gridCSGV.pagerModule.pagerObj.currentPage;
            this.CSGGridList.pageitem =
                this.gridCSGV.pagerModule.pagerObj.pageSize;
            if (G.name == "actionBegin" && G.requestType == "filterbeforeopen") {
                this.CSGGridList.type = G.columnType;
            }
        }
    }

    cellEdit(args: CellEditArgs) {
        if (args.value === "Ready") {
            args.cancel = true;
        }
    }

    rowDataBound(args) {
        if (args.data['claimStatus'] == 'Validate') {
            args.row.getElementsByClassName('e-gridchkbox')[0].classList.add('disablecheckbox');
            args.row.getElementsByClassName('e-checkbox-wrapper')[0].classList.add('disablecheckbox');
        }
        if(args.data['isCFSS'] == true) {
             args.row.getElementsByClassName('e-gridchkbox')[0].classList.add('disablecheckbox');
            args.row.getElementsByClassName('e-checkbox-wrapper')[0].classList.add('disablecheckbox');
        }
        if (this.activeTab == "TimesheetVerification") {
            this.TimesheetVerficationList?.forEach((element) => {
                if (args.data["timesheetId"] == element) {
                    args.rowHeight = "25";
                    this.selIndex.push(
                        parseInt(args.row.getAttribute("aria-rowindex"), 10)
                    );
                }
            });
        }
        if (this.activeTab == "TransactionVerification") {
            this.TransactionVerficationList?.forEach((element) => {
                if (args.data["transactionId"] == element) {
                    args.rowHeight = "25";
                    this.selIndex.push(
                        parseInt(args.row.getAttribute("aria-rowindex"), 10)
                    );
                }
            });
        }
        if (this.activeTab == "PurchseVerification") {
            this.PurchaseVerficationList?.forEach((element) => {
                if (args.data["purchaseRequestId"] == element) {
                    args.rowHeight = "25";
                    this.selIndex.push(
                        parseInt(args.row.getAttribute("aria-rowindex"), 10)
                    );
                }
            });
        }
        if (this.activeTab == "CSGVerification") {
            this.CSGVerficationList?.forEach((element) => {
                if (args.data["id"] == element) {
                    args.rowHeight = "25";
                    this.selIndex.push(
                        parseInt(args.row.getAttribute("aria-rowindex"), 10)
                    );
                }
            });
        }

        if (args.data["bit"] > 0) {
            args.rowHeight = "25";
            args.row
                .getElementsByClassName("e-gridchkbox")[0]
                .classList.add("disablecheckbox");
            args.row
                .getElementsByClassName("e-checkbox-wrapper")[0]
                .classList.add("disablecheckbox");
        }
        console.log(this.TimesheetVerficationList, this.TransactionVerficationList, this.CSGVerficationList)
    }

    public dataStateChange(state): void {
        if (this.activeTab == "TimesheetVerification") {
            this.documentType = state.action.requestType.toString();

            if (this.documentType != "filterchoicerequest") {
                if ((state.sorted || []).length) {
                    this.TimesheetGridList.orderColumn = state.sorted[0].name;
                    this.TimesheetGridList.orderType =
                        state.sorted[0].direction === "descending" ? "DESC" : "ASC";
                }
            }
            if (
                this.documentType == "filtering" &&
                state.action.action != "clearFilter"
            ) {
                this.TimesheetGridList.field = state.action.currentFilterObject.field;
                this.TimesheetGridList.matchCase =
                    state.action.currentFilterObject.matchCase;
                this.TimesheetGridList.operator =
                    state.action.currentFilterObject.operator;
                this.TimesheetGridList.value = state.action.currentFilterObject.value;
                if(this.TimesheetGridList.type == "number"){
                    this.TimesheetGridList.value = (this.TimesheetGridList.value!=null && this.TimesheetGridList.value!=undefined)
                    ? this.TimesheetGridList.value.toString() : null;
                }
            } else {
                if (
                    this.documentType == "filtering" &&
                    state.action.action == "clearFilter"
                ) {
                    this.TimesheetGridList.field = "claimStatus";
                    this.TimesheetGridList.matchCase = false;
                    this.TimesheetGridList.operator = "startswith";
                    this.TimesheetGridList.value = "";
                    this.TimesheetGridList.type = "string";
                }
            }
            if (this.documentType != "refresh") {
                this.getTimesheetVList();
            }
        }
        if (this.activeTab == "TransactionVerification") {
            this.documentType = state.action.requestType.toString();

            if (this.documentType != "filterchoicerequest") {
                if ((state.sorted || []).length) {
                    this.TransactionGridList.orderColumn = state.sorted[0].name;
                    this.TransactionGridList.orderType =
                        state.sorted[0].direction === "descending" ? "DESC" : "ASC";
                }
            }
            if (
                this.documentType == "filtering" &&
                state.action.action != "clearFilter"
            ) {
                this.TransactionGridList.field = state.action.currentFilterObject.field;
                this.TransactionGridList.matchCase =
                    state.action.currentFilterObject.matchCase;
                this.TransactionGridList.operator =
                    state.action.currentFilterObject.operator;
                this.TransactionGridList.value = state.action.currentFilterObject.value;
                if(this.TransactionGridList.type == "number"){
                    this.TransactionGridList.value = (this.TransactionGridList.value!=null && this.TransactionGridList.value!=undefined)
                    ? this.TransactionGridList.value.toString() : null;
                }
            } else {
                if (
                    this.documentType == "filtering" &&
                    state.action.action == "clearFilter"
                ) {
                    this.TransactionGridList.field = "claimStatus";
                    this.TransactionGridList.matchCase = false;
                    this.TransactionGridList.operator = "startswith";
                    this.TransactionGridList.value = "";
                    this.TransactionGridList.type = "string";
                }
            }
            if (this.documentType != "refresh") {
                this.getTransactionVList();
            }
        }
        if (this.activeTab == "PurchseVerification") {
            this.documentType = state.action.requestType.toString();

            if (this.documentType != "filterchoicerequest") {
                if ((state.sorted || []).length) {
                    this.PurchaseGridList.orderColumn = state.sorted[0].name;
                    this.PurchaseGridList.orderType =
                        state.sorted[0].direction === "descending" ? "DESC" : "ASC";
                }
            }
            if (
                this.documentType == "filtering" &&
                state.action.action != "clearFilter"
            ) {
                this.PurchaseGridList.field = state.action.currentFilterObject.field;
                this.PurchaseGridList.matchCase =
                    state.action.currentFilterObject.matchCase;
                this.PurchaseGridList.operator =
                    state.action.currentFilterObject.operator;
                this.PurchaseGridList.value = state.action.currentFilterObject.value;
                if(this.PurchaseGridList.type == "number"){
                    this.PurchaseGridList.value = (this.PurchaseGridList.value!=null && this.PurchaseGridList.value!=undefined)
                    ? this.PurchaseGridList.value.toString() : null;
                }
            } else {
                if (
                    this.documentType == "filtering" &&
                    state.action.action == "clearFilter"
                ) {
                    this.PurchaseGridList.field = "claimStatus";
                    this.PurchaseGridList.matchCase = false;
                    this.PurchaseGridList.operator = "startswith";
                    this.PurchaseGridList.value = "";
                    this.PurchaseGridList.type = "string";
                }
            }
            if (this.documentType != "refresh") {
                this.getPurchaseVList();
            }
        }
        if (this.activeTab == "CSGVerification") {
            this.documentType = state.action.requestType.toString();

            if (this.documentType != "filterchoicerequest") {
                if ((state.sorted || []).length) {
                    this.CSGGridList.orderColumn = state.sorted[0].name;
                    this.CSGGridList.orderType =
                        state.sorted[0].direction === "descending" ? "DESC" : "ASC";
                }
            }
            if (
                this.documentType == "filtering" &&
                state.action.action != "clearFilter"
            ) {
                this.CSGGridList.field = state.action.currentFilterObject.field;
                this.CSGGridList.matchCase =
                    state.action.currentFilterObject.matchCase;
                this.CSGGridList.operator =
                    state.action.currentFilterObject.operator;
                this.CSGGridList.value = state.action.currentFilterObject.value;
                if(this.CSGGridList.type == "number"){
                    this.CSGGridList.value = (this.CSGGridList.value!=null && this.CSGGridList.value!=undefined)
                    ? this.CSGGridList.value.toString() : null;
                }
            } else {
                if (
                    this.documentType == "filtering" &&
                    state.action.action == "clearFilter"
                ) {
                    this.CSGGridList.field = "claimStatus";
                    this.CSGGridList.matchCase = false;
                    this.CSGGridList.operator = "startswith";
                    this.CSGGridList.value = "";
                    this.CSGGridList.type = "string";
                }
            }
            if (this.documentType != "refresh") {
                this.getCSGVList();
            }
        }
    }

    CheckBoxClickEvent(args) {
        var customselect = [];
        if (this.activeTab == "TimesheetVerification") {
            this.selectedtimesheets = [];
            if (args.checked && args.target.classList.contains("e-checkselectall")) {
                for (var i = 0; i < args.selectedRowIndexes.length; i++) {
                    var row = this.gridTimesheetV.getRowByIndex(args.selectedRowIndexes[i]);
                    if (!row.querySelector('.disablecheckbox')) {
                        this.selectedtimesheets = []
                        customselect.push(args.selectedRowIndexes[i])
                    }

                }
                this.gridTimesheetV.selectRows(customselect)
                this.timesheetVList.forEach((e, index) => {
                    customselect.forEach(element => {
                        if (element == index) {
                            this.selectedtimesheets.push(e);
                        }
                    })

                })
            }
            else if (args.target.classList.contains("e-checkselect")) {
                let rowsdata: any = this.gridTimesheetV.getSelectedRecords();
                let list = rowsdata.map(d => d.TimesheetId)
                this.timesheetVList.forEach((e) => {
                    list?.forEach(id => {
                        if (e.timesheetId == id) {
                            this.selectedtimesheets.push(e);
                        }
                    })
                })

            }
        }
        if (this.activeTab == "TransactionVerification") {
            this.selectedtransactions = [];
            if (args.checked && args.target.classList.contains("e-checkselectall")) {
                for (var i = 0; i < args.selectedRowIndexes.length; i++) {
                    var row = this.gridTransactionV.getRowByIndex(args.selectedRowIndexes[i]);
                    if (!row.querySelector('.disablecheckbox')) {
                        this.selectedtransactions = []
                        customselect.push(args.selectedRowIndexes[i])
                    }
                }
                this.gridTransactionV.selectRows(customselect)
                this.transactionVList.forEach((e, index) => {
                    customselect.forEach(element => {
                        if (element == index) {
                            this.selectedtransactions.push(e);
                        }
                    })

                })
            }
            else if (args.target.classList.contains("e-checkselect")) {
                let rowsdata: any = this.gridTransactionV.getSelectedRecords();
                let list = rowsdata.map(d => d.transactionId)
                this.transactionVList.forEach((e) => {
                    list?.forEach(id => {
                        if (e.transactionId == id) {
                            this.selectedtransactions.push(e);
                        }
                    })
                })
            }
        }
        if (this.activeTab == "PurchseVerification") {
            this.selectedpurchases = [];
            if (args.checked && args.target.classList.contains("e-checkselectall")) {
                for (var i = 0; i < args.selectedRowIndexes.length; i++) {
                    var row = this.gridPurchaseV.getRowByIndex(args.selectedRowIndexes[i]);
                    if (!row.querySelector('.disablecheckbox')) {
                        this.selectedpurchases = []
                        customselect.push(args.selectedRowIndexes[i])
                    }
                }
                this.gridPurchaseV.selectRows(customselect)
                this.purchaseVList.forEach((e, index) => {
                    customselect.forEach(element => {
                        if (element == index) {
                            this.selectedpurchases.push(e);
                        }
                    })

                })
            }
            else if (args.target.classList.contains("e-checkselect")) {
                let rowsdata: any = this.gridPurchaseV.getSelectedRecords();
                let list = rowsdata.map(d => d.purchaseRequestId)
                this.purchaseVList.forEach((e) => {
                    list?.forEach(id => {
                        if (e.purchaseRequestId == id) {
                            this.selectedpurchases.push(e);
                        }
                    })
                })
            }
        }
        if (this.activeTab == "CSGVerification") {
            this.selectedcsgs = [];
            if (args.checked && args.target.classList.contains("e-checkselectall")) {
                for (var i = 0; i < args.selectedRowIndexes.length; i++) {
                    var row = this.gridCSGV.getRowByIndex(args.selectedRowIndexes[i]);
                    if (!row.querySelector('.disablecheckbox')) {
                        this.selectedcsgs = []
                        customselect.push(args.selectedRowIndexes[i])
                    }
                }
                this.gridCSGV.selectRows(customselect)
                this.csgVList.forEach((e, index) => {
                    customselect.forEach(element => {
                        if (element == index) {
                            this.selectedcsgs.push(e);
                        }
                    })

                })
            }
            else if (args.target.classList.contains("e-checkselect")) {
                let rowsdata: any = this.gridCSGV.getSelectedRecords();
                let list = rowsdata.map(d => d.id)
                this.csgVList.forEach((e) => {
                    list?.forEach(id => {
                        if (e.id == id) {
                            this.selectedcsgs.push(e);
                        }
                    })
                })
            }
        }
    }

    showerrors(args) {
        this.isEnabled = false;
        this.showerrorlist1 = [];
        this.showerrorlistfilter1 = [];
        var grid = parentsUntil(args.target, "e-grid") as any;
        this.result3 = grid.ej2_instances[0].getRowInfo(args.target).rowData;
        // this.startDateauth = this.result3.fromDate;
        // this.endDateauth = this.result3.toDate;
        if (this.activeTab == "TimesheetVerification") {
            let TimesheetId = this.result3.timesheetId;

            this.errorlist1.forEach((element) => {
                if (element.timesheetId == TimesheetId) {
                    this.showerrorlist1.push(element);
                    JSON.parse(JSON.stringify(this.showerrorlistfilter1.push(element)));
                }
            });
        }
        if (this.activeTab == "TransactionVerification") {
            let transactionId = this.result3.transactionId;

            this.errorlist2.forEach((element) => {
                if (element.transactionId == transactionId) {
                    this.showerrorlist1.push(element);
                    JSON.parse(JSON.stringify(this.showerrorlistfilter1.push(element)));
                }
            });
        }
        if (this.activeTab == "PurchseVerification") {
            let purchaseRequestId = this.result3.purchaseRequestId;

            this.errorlist3.forEach((element) => {
                if (element.purchaseRequestId == purchaseRequestId) {
                    this.showerrorlist1.push(element);
                    JSON.parse(JSON.stringify(this.showerrorlistfilter1.push(element)));
                }
            });
        }
        if (this.activeTab == "CSGVerification") {
            let verificationId = this.result3.id;

            this.errorlist4.forEach((element) => {
                if (element.id == verificationId) {
                    this.showerrorlist1.push(element);
                    JSON.parse(JSON.stringify(this.showerrorlistfilter1.push(element)));
                }
            });
        }
    }

    colseerr() {
        document.getElementById("OpenModal2").click();
    }

    SelectErrorData() {
        this.global.loading = false;
        if (this.isEnabled == true) {
            this.showerrorlist1 = this.showerrorlistfilter1.filter(
                (s) => s.isValid == false
            );
        } else {
            this.showerrorlist1 = this.showerrorlistfilter1;
        }
    }

    selecttobill() {
        var url;
        this.sendToBillinProgress = true;
        if (this.activeTab == "TimesheetVerification") {
      this.gridTimesheetV.dataSource=[];

            this.global.checkidleTime = true;
            this.global.checkProgressTimesheet = null;
            if (this.global.checkProgressPurchase == false) {
                this.global.checkProgressPurchase = null
            }
            else if (this.global.checkProgressTransaction == false) {
                this.global.checkProgressTransaction = null
            }
            else if (this.global.checkProgressCSG == false) {
                this.global.checkProgressCSG = null
            }

            if (this.selectedtimesheets.length != 0) {
                url = "api/Claims/saveTimesheetClaims";
                this.verificationsService.Selectbill(this.selectedtimesheets, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
                    this.selectedtimesheets = [];
                    this.global.scheduleClaimProgressForTimesheet(data.progressId)
                    // this.getTimesheetVList();
                    this.sendToBillinProgress = false;
                }, (err: any) => {
                    if (err) {
                        this.toasterService.error(err), 8000;
                        this.sendToBillinProgress = false;
                    }
                });
            }
        }
        if (this.activeTab == "TransactionVerification") {
            this.gridTransactionV.dataSource=[]
            this.global.checkidleTransaction = true;
            this.global.checkProgressTransaction = null;

            if (this.global.checkProgressPurchase == false) {
                this.global.checkProgressPurchase = null
            }
            else if (this.global.checkProgressTimesheet == false) {
                this.global.checkProgressTimesheet = null
            }
            else if (this.global.checkProgressCSG == false) {
                this.global.checkProgressCSG = null
            }

            if (this.selectedtransactions.length != 0) {
                url = "api/Claims/saveTransactionClaims";
                this.verificationsService.Selectbill(this.selectedtransactions, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
                    this.selectedtransactions = [];
                    this.global.scheduleClaimProgressForTransaction(data.progressId)
                    // this.getTransactionVList();
                    this.sendToBillinProgress = false;
                }, (err: any) => {
                    if (err) {
                        this.toasterService.error(err), 8000;
                        this.sendToBillinProgress = false;
                    }
                });
            }
        }
        if (this.activeTab == "PurchseVerification") {
            this.gridPurchaseV.dataSource=[]
            this.global.checkidlePurchase = true;
            this.global.checkProgressPurchase = null;
            if (this.global.checkProgressTimesheet == false) {
                this.global.checkProgressTimesheet = null
            }
            else if (this.global.checkProgressTransaction == false) {
                this.global.checkProgressTransaction = null
            }
            else if (this.global.checkProgressCSG == false) {
                this.global.checkProgressCSG = null
            }

            if (this.selectedpurchases.length != 0) {
                url = "api/Claims/savePurchaseRequestClaims";
                this.verificationsService.Selectbill(this.selectedpurchases, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
                    this.selectedpurchases = [];
                    this.global.scheduleClaimProgressForPurchase(data.progressId)
                    // this.getPurchaseVList();
                    this.sendToBillinProgress = false;
                }, (err: any) => {
                    if (err) {
                        this.toasterService.error(err), 8000;
                        this.sendToBillinProgress = false;
                    }
                });
            }
        }
        if (this.activeTab == "CSGVerification") {
            this.gridCSGV.dataSource=[]
            this.global.checkidleCSG = true;
            this.global.checkProgressCSG = null;
            if (this.global.checkProgressTimesheet == false) {
                this.global.checkProgressTimesheet = null
            }
            else if (this.global.checkProgressTransaction == false) {
                this.global.checkProgressTransaction = null
            }
            else if (this.global.checkProgressPurchase == false) {
                this.global.checkProgressPurchase = null
            }

            if (this.selectedcsgs.length != 0) {
                url = "api/Claims/saveCSGClaims";
                this.verificationsService.Selectbill(this.selectedcsgs, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
                    this.selectedcsgs = [];
                    this.global.scheduleClaimProgressForCSG(data.progressId);
                    // this.getCSGVList();
                    this.sendToBillinProgress = false;
                }, (err: any) => {
                    if (err) {
                        this.toasterService.error(err), 8000;
                        this.sendToBillinProgress = false;
                    }
                });
            }
        }
    }

    apply() {
        if(this.activeTab == 'TimesheetVerification'){
            this.TimesheetGridList.orderColumn = "timesheetDate";
            this.TimesheetGridList.orderType = "asc";
            this.TimesheetGridList.pageitem=this.gridTimesheetV.pagerModule.pagerObj.pageSize;
            this.TimesheetGridList.isApproved=this.ApproveFilter;
            this.getTimesheetVList();
        }
        if(this.activeTab == 'TransactionVerification'){
            this.TransactionGridList.orderColumn = "transactionDate";
            this.TransactionGridList.orderType = "asc";
            this.TransactionGridList.pageitem = this.gridTransactionV.pagerModule.pagerObj.pageSize; 
            this.TransactionGridList.isApproved=this.ApproveFilter;
            this.getTransactionVList();
        }
        if(this.activeTab == "PurchseVerification"){
            this.PurchaseGridList.orderColumn = "purchaseRequestDate";
            this.PurchaseGridList.orderType = "asc";
            this.PurchaseGridList.pageitem = this.gridPurchaseV.pagerModule.pagerObj.pageSize;
            this.PurchaseGridList.isApproved=this.ApproveFilter;
            this.getPurchaseVList();
        }
        if(this.activeTab == "CSGVerification"){
            this.CSGGridList.orderColumn = "createdDate";
            this.CSGGridList.orderType = "asc";
            this.CSGGridList.pageitem = this.gridCSGV.pagerModule.pagerObj.pageSize;
            this.CSGGridList.isApproved=this.ApproveFilter;
            this.getCSGVList();
        }
    }

    refresh() {
        this.fromDate = this.toDate = new Date().getMonth() + 1 + "/" + new Date().getDate() + "/" + new Date().getFullYear();
        this.verificationBO.employeeId = this.verificationBO.clientId = null; //this.verificationBO.serviceId =
        this.apply();
    }

    getTimesheetVList() {
        if (this.global.checkProgressTimesheet == true) {
            this.toasterService.error("Billing is inProgress!");
            return;
        }

        this.errorlist1 = [];
        //this.emitpayer.TimsheetV_payer = false;
        this.TimesheetGridList.agencyId = this.global.globalAgencyId;
        //this.TimesheetGridList.requesttype = "aaa";
        //this.TimesheetGridList.timesheetType = "aaa";
        this.TimesheetGridList.fromDate = this.fromDate;
        this.TimesheetGridList.toDate = this.toDate;
        this.TimesheetGridList.clientid = this.verificationBO.clientId;
        this.TimesheetGridList.employeeid = this.verificationBO.employeeId;
        // this.TimesheetGridList.serviceid = this.verificationBO.serviceId;
        this.TimesheetGridList.fromDate =
            this.TimesheetGridList.fromDate != null &&
                this.TimesheetGridList.fromDate != undefined &&
                this.TimesheetGridList.fromDate != ""
                ? this.global.getDateTimeString(this.TimesheetGridList.fromDate)
                : null;
        this.TimesheetGridList.toDate =
            this.TimesheetGridList.toDate != null &&
                this.TimesheetGridList.toDate != undefined &&
                this.TimesheetGridList.toDate != ""
                ? this.global.getDateTimeString(this.TimesheetGridList.toDate)
                : null;
        this.TimesheetGridList.status = this.verificationBO?.status;
        if(this.DecimalColumns.includes(this.TimesheetGridList.field.toUpperCase())){
            this.TimesheetGridList.type = "decimal";
        }

        if(this.TimesheetGridList.type != "string" && (this.TimesheetGridList.value == ""
            || this.TimesheetGridList.value == undefined || this.TimesheetGridList.value == null)){
                this.TimesheetGridList.field = "claimStatus";
                this.TimesheetGridList.matchCase = false;
                this.TimesheetGridList.operator = "startswith";
                this.TimesheetGridList.value = "";
                this.TimesheetGridList.type = "string";
        }
        this.timesheetVListService.execute(this.TimesheetGridList);
        this.GridTimesheetVList.pipe(takeUntil(this.onDestroy$)).subscribe(
            (data: any) => {
                this.timesheetVList = []
                this.timesheetVList = this.timesheetVListService.gettimesheetVerifyList();
                this.errorlist1 = [];
                this.errorlist1 = this.timesheetVListService.getErrorlist();

                this.TimesheetVerficationList =
                    this.timesheetVListService.getAllTimeshettList();
                //this.ErrorNotesTimesheetV = this.timesheetVListService.getErrorNotes();
            }
        );
    }

    getTransactionVList() {
        if (this.global.checkProgressTransaction == true) {
            this.toasterService.error("Billing is inProgress!");
            return;
        }
        this.errorlist2 = [];
        //this.emitpayer.TimsheetV_payer = false;
        this.TransactionGridList.agencyId = this.global.globalAgencyId;
        //this.TimesheetGridList.requesttype = "aaa";
        this.TransactionGridList.fromDate = this.global.getDateTimeString(this.fromDate)
        this.TransactionGridList.toDate = this.global.getDateTimeString(this.toDate)
        this.TransactionGridList.clientId = this.verificationBO.clientId;
        // this.TransactionGridList.serviceId = this.verificationBO.serviceId;
        this.TransactionGridList.ids = this.fromClaim?.ids;
        this.TransactionGridList.status = this.verificationBO?.status;
        if(this.DecimalColumns.includes(this.TransactionGridList.field.toUpperCase())){
            this.TransactionGridList.type = "decimal";
        }

        if(this.TransactionGridList.type != "string" && (this.TransactionGridList.value == ""
            || this.TransactionGridList.value == undefined || this.TransactionGridList.value == null)){
               this.TransactionGridList.field = "claimStatus";
               this.TransactionGridList.matchCase = false;
               this.TransactionGridList.operator = "startswith";
               this.TransactionGridList.value = "";
               this.TransactionGridList.type = "string";
       }
        this.transactionVListService.execute(this.TransactionGridList);
        this.GridTransactionVList.pipe(takeUntil(this.onDestroy$)).subscribe(
            (data: any) => {
                this.errorlist2 = [];
                this.transactionVList = this.transactionVListService.gettimesheetVerifyList();
                this.errorlist2 = this.transactionVListService.getErrorlist();
                this.TimesheetVerficationList =
                    this.transactionVListService.getAllTimeshettList();
                //this.ErrorNotesTimesheetV = this.transactionVListService.getErrorNotes();
            }
        );
    }

    getPurchaseVList() {
        if (this.global.checkProgressPurchase == true) {
            this.toasterService.error("Billing is inProgress!");
            return;
        }
        this.errorlist3 = [];
        //this.emitpayer.TimsheetV_payer = false;
        this.PurchaseGridList.agencyId = this.global.globalAgencyId;
        //this.TimesheetGridList.requesttype = "aaa";
        this.PurchaseGridList.fromDate = this.global.getDateTimeString(this.fromDate)
        this.PurchaseGridList.toDate = this.global.getDateTimeString(this.toDate)
        this.PurchaseGridList.clientId = this.verificationBO.clientId;
        // this.PurchaseGridList.serviceId = this.verificationBO.serviceId;
        this.PurchaseGridList.ids = this.fromClaim?.ids;
        this.PurchaseGridList.status = this.verificationBO?.status;
        if(this.DecimalColumns.includes(this.PurchaseGridList.field.toUpperCase())){
            this.PurchaseGridList.type = "decimal";
        }
        if(this.PurchaseGridList.type != "string" && (this.PurchaseGridList.value == ""
            || this.PurchaseGridList.value == undefined || this.PurchaseGridList.value == null)){
                this.PurchaseGridList.field = "claimStatus";
                this.PurchaseGridList.matchCase = false;
                this.PurchaseGridList.operator = "startswith";
                this.PurchaseGridList.value = "";
                this.PurchaseGridList.type = "string";
        }

        this.purchaseVListService.execute(this.PurchaseGridList);
        this.GridPurchaseVList.pipe(takeUntil(this.onDestroy$)).subscribe(
            (data: any) => {
                this.purchaseVList = this.purchaseVListService.gettimesheetVerifyList();
                this.errorlist3 = [];
                this.errorlist3 = this.purchaseVListService.getErrorlist();
                this.PurchaseVerficationList =
                    this.purchaseVListService.getAllTimeshettList();
                //this.ErrorNotesTimesheetV = this.timesheetVListService.getErrorNotes();
            }
        );
    }

    getCSGVList() {
        console.log("Inside grid CSGVList");
        if (this.global.checkProgressCSG == true) {
            this.toasterService.error("Billing is inProgress!");
            return;
        }
       
        this.errorlist4 = [];
        //this.emitpayer.TimsheetV_payer = false;
        this.CSGGridList.agencyId = this.global.globalAgencyId;
        //this.TimesheetGridList.requesttype = "aaa";
        this.CSGGridList.fromDate = this.global.getDateTimeString(this.fromDate)
        this.CSGGridList.toDate = this.global.getDateTimeString(this.toDate)
        this.CSGGridList.clientId = this.verificationBO.clientId;
        this.CSGGridList.employeeId = this.verificationBO.employeeId;
        // this.CSGGridList.serviceId = this.verificationBO.serviceId;
        this.CSGGridList.isCommonVerification = true;
        this.CSGGridList.ids = this.fromClaim?.ids;
        this.CSGGridList.status = this.verificationBO?.status;
       // this.CSGGridList.billType = (this.verificationBO?.billType!=null&&this.verificationBO?.billType!=undefined&&this.verificationBO?.billType!='')?this.verificationBO?.billType:"CSG";
        if(this.DecimalColumns.includes(this.CSGGridList.field.toUpperCase())){
            this.CSGGridList.type = "decimal";
        }
        if(this.CSGGridList.type != "string" && (this.CSGGridList.value == "" || this.CSGGridList.value == undefined || 
            this.CSGGridList.value == null)){
                this.CSGGridList.field = "claimStatus";
                this.CSGGridList.matchCase = false;
                this.CSGGridList.operator = "startswith";
                this.CSGGridList.value = "";
                this.CSGGridList.type = "string";
        }

        this.combinedVerificationService.execute(this.CSGGridList);
        this.GridCSGVList.pipe(takeUntil(this.onDestroy$)).subscribe(
            (data: any) => {
                console.log("In side Grid data",data)
                this.csgVList = this.combinedVerificationService.gettimesheetVerifyList();
                this.errorlist4 = [];
                this.errorlist4 = this.combinedVerificationService.getErrorlist();
                this.CSGVerficationList =
                    this.combinedVerificationService.getAllTimeshettList();
                //this.ErrorNotesTimesheetV = this.timesheetVListService.getErrorNotes();
                console.log("end");
            }
        );
    }

    ///........................................updateClaim....................................................
    updateClaim() {
        this.sendToBillinProgress = true;
        console.log(this.selectedtransactions,"selectedtransactions");
        if ((this.selectedtransactions == null || this.selectedtransactions?.length == 0 && this.activeTab == "TransactionVerification")
            || (this.selectedtimesheets == null || this.selectedtimesheets?.length == 0 && this.activeTab == "TimesheetVerification")
            || (this.selectedpurchases == null || this.selectedpurchases?.length == 0 && this.activeTab == "PurchseVerification")
            || (this.selectedcsgs == null || this.selectedcsgs?.length == 0 && this.activeTab == "CSGVerification")) {
            this.toasterService.error('No Record Selected for update !!!');
              this.sendToBillinProgress = false;
            setTimeout(() => {
                this.toasterService.clear();
            }, 8000);
        }
        else if (this.selectedtransactions?.length != 0 || this.selectedtimesheets?.length != 0 || this.selectedcsgs?.length != 0 ) {
            let obj: UpdateClaimBO = new UpdateClaimBO();
            obj.claimType = this.selectedtransactions?.length != 0 ? 'TRANSACTION' : ((this.selectedtimesheets?.length != 0 && this.selectedtimesheets.every(t => t.serviceCode != "T1019")) ? "TIMESHEET" : (this.selectedtimesheets?.length != 0 && this.selectedtimesheets.every(t => t.serviceCode == "T1019") ? "CFSS" : (this.selectedcsgs?.length != 0 ? "CSG" : "")));
            obj.claimMasterId = this.fromClaim.claimId;
            obj.transactionVerificationData = this.selectedtransactions;
            obj.timesheetVerificationData = this.selectedtimesheets;
            obj.csgVerificationData = this.selectedcsgs;

            let url = "api/Claims/UpdateClaims";
            this.verificationsService.UpdateClaim(obj, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: number) => {
                this.selectedtransactions = [];
                this.sendToBillinProgress = false;
                // this.fromClaim.errorValidation = false;
                // this.ListSendBO.requesttype = "getdata";
                this.toasterService.success('Selected Record updated successfully!');
                this.sendToBillinProgress = false;
                setTimeout(() => {
                    this.toasterService.clear();
                }, 8000);
                this.outclaim.emit(this.fromClaim.claimId);
                return;
            }, (err: any) => {
                this.toasterService.error(err);
                this.sendToBillinProgress = false;
                setTimeout(() => {
                    this.toasterService.clear();
                }, 8000);

            }
            );
        }
    }
}

